import { useEffect, useRef } from "react"
import useSfx from "../../utils/useSfx"

export default function Ovni() {

    const { soundRef, loadedRef, targetVolume } = useSfx("/audio/sfx/vaisseaux2.wav")
    const pressedCountRef = useRef(0)

    const keys = (key) =>
        key === "ArrowUp" ||
        key === "ArrowDown" ||
        key === "ArrowLeft" ||
        key === "ArrowRight" ||
        key === "z" || key === "w" ||
        key === "q" || key === "a" ||
        key === "s" ||
        key === "d"

    const handleKeyDown = (e) => {
        if (!keys(e.key)) return
        if (e.repeat) return

        pressedCountRef.current += 1

        if (!loadedRef.current) return

        targetVolume.current = 0.4

        if (!soundRef.current?.isPlaying) {
            soundRef.current.play(0)
        }
    }

    const handleKeyUp = (e) => {
        if (!keys(e.key)) return
        pressedCountRef.current = Math.max(0, pressedCountRef.current - 1)

        if (pressedCountRef.current === 0 && soundRef.current?.isPlaying) {
            targetVolume.current = 0
        }
    }

    const handleJoyDown = () => {
        pressedCountRef.current += 1

        if (!loadedRef.current) return

        targetVolume.current = 0.4
        if (!soundRef.current?.isPlaying) soundRef.current.play(0)
    }

    const handleJoyUp = () => {
        pressedCountRef.current = Math.max(0, pressedCountRef.current - 1)
        if (pressedCountRef.current === 0 && soundRef.current?.isPlaying) {
            targetVolume.current = 0
        }
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        window.addEventListener("keyup", handleKeyUp)

        window.addEventListener("joystickdown", handleJoyDown)
        window.addEventListener("joystickup", handleJoyUp)

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
            window.removeEventListener("keyup", handleKeyUp)

            window.removeEventListener("joystickdown", handleJoyDown)
            window.removeEventListener("joystickup", handleJoyUp)
        }
    }, [])
    return null
}